import { createReducer, on } from '@ngrx/store';
import {
  Navigated,
  NavigationSetPropsStart,
  NavigationStart,
} from './router.actions';
import { RouterStateUrl } from './router.model';
import { routerInitState } from './router.state';

export const routerReducer = createReducer(
  routerInitState,

  on(Navigated, (state, { state: routerStateUrl }) => ({
    ...state,
    prev: { ...state.state },
    state: sanitizeParams(routerStateUrl),
    navigationId: state.navigationId + 1,
    loading: false,
  })),

  on(NavigationStart, (state) => ({
    ...state,
    loading: true,
  })),

  on(NavigationSetPropsStart, (state, { params }) => ({
    ...state,
    state: sanitizeParams({
      ...state.state,
      params: {
        ...state.state.params,
        ...params,
      },
    }),
  })),
);

function sanitizeParams(state: RouterStateUrl): RouterStateUrl {
  if (state == null || typeof state !== 'object') {
    return state;
  }

  if (state?.params?.orgId) {
    state.params.orgId = state.params.orgId.toLowerCase();
  }

  return state;
}
